import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCheck = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M18.5303 7.71967C18.8232 8.01256 18.8232 8.48744 18.5303 8.78033L11.0303 16.2803C10.7374 16.5732 10.2626 16.5732 9.96967 16.2803L6.21967 12.5303C5.92678 12.2374 5.92678 11.7626 6.21967 11.4697C6.51256 11.1768 6.98744 11.1768 7.28033 11.4697L10.5 14.6893L17.4697 7.71967C17.7626 7.42678 18.2374 7.42678 18.5303 7.71967Z",
		fill: "currentColor"
	})
});
export default SvgCheck;
